import { z } from 'zod/v4';
import { countryEnum, durationEnum } from '~/schemas/enums';
import { zodIsoDate } from './custom-schemas';

const period = z.object({
  end_time: zodIsoDate,
  start_time: zodIsoDate,
});

// Consumer and Supply latest response
export const latestPeriodResponse = z.object({
  month: period,
});

export type LatestPeriod = z.infer<typeof latestPeriodResponse>;

export const perimeterProductionDevicesSchema = z.object({
  country: countryEnum,
  durations: z.array(durationEnum),
  name: z.string(),
  technology: z.string(),
  uuid: z.uuid(),
});

export type PerimeterProductionDevice = z.infer<typeof perimeterProductionDevicesSchema>;

export const perimeterConsumersSchema = z.object({
  country: countryEnum,
  durations: z.array(durationEnum),
  name: z.string(),
  uuid: z.uuid(),
});

export type PerimeterConsumer = z.infer<typeof perimeterConsumersSchema>;

export const perimeterSchema = z.object({
  consumers_with_consumption: z.array(perimeterConsumersSchema),
  durations: z.array(durationEnum),
  end_datetime: zodIsoDate,
  production_devices_with_production: z.array(perimeterProductionDevicesSchema),
  start_datetime: zodIsoDate,
});
